import { Routes } from "@angular/router";
import { AuthGuard } from "./auth.guard";

export const routes: Routes = [
  {
    path: "app",
    loadComponent: () => import("./pages/pages.component").then((m) => m.PagesComponent),
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "main", pathMatch: "full" },
      {
        path: "main",
        loadComponent: () => import("./layouts/main/main.component").then((m) => m.MainComponent),
        children: [
          {
            path: "",
            loadComponent: () => import("./pages/sports-bar/sports-bar.component").then((m) => m.SportsBarComponent),
            outlet: "navigation",
            children: [
              {
                path: "sports",
                loadComponent: () => import("./pages/sports-bar/sports/sports.component").then((m) => m.SportsComponent),
              },
              {
                path: ":type/:id",
                loadComponent: () => import("./pages/sports-bar/navigation-item/navigation-item.component").then((m) => m.NavigationItemComponent),
              },
              { path: "", redirectTo: "sports", pathMatch: "full" },
            ],
          },
          {
            path: "",
            loadComponent: () => import("./pages/content/content.component").then((m) => m.ContentComponent),
            outlet: "content",
            children: [
              {
                path: "home",
                loadComponent: () => import("./pages/content/home/home.component").then((m) => m.HomeComponent),
                children: [
                  {
                    path: "highlights",
                    loadComponent: () => import("./pages/content/home/sport-highlights/sport-highlights.component").then((m) => m.SportHighlightsComponent),
                  },
                  {
                    path: "highlights/:sport",
                    loadComponent: () => import("./pages/content/home/sport-highlights/sport-highlights.component").then((m) => m.SportHighlightsComponent),
                  },
                  {
                    path: "",
                    redirectTo: "highlights/cricket",
                    pathMatch: "full",
                  },
                ],
              },
              {
                path: "in-play",
                loadComponent: () => import("./pages/content/in-play/in-play.component").then((m) => m.InPlayComponent),
                children: [
                  {
                    path: "current",
                    loadComponent: () => import("./pages/content/in-play/in-play-markets/in-play-markets.component").then((m) => m.InPlayMarketsComponent),
                  },
                  {
                    path: "today",
                    loadComponent: () => import("./pages/content/in-play/today-markets/today-markets.component").then((m) => m.TodayMarketsComponent),
                  },
                  {
                    path: "tomorrow",
                    loadComponent: () => import("./pages/content/in-play/tomorrow-markets/tomorrow-markets.component").then((m) => m.TomorrowMarketsComponent),
                  },
                  {
                    path: "",
                    redirectTo: "current",
                    pathMatch: "full",
                  },
                ],
              },
              { path: "my-markets", loadComponent: () => import("./pages/content/my-markets/my-markets.component").then((m) => m.MyMarketsComponent) },
              {
                path: ":sport",
                loadComponent: () => import("./pages/content/sport-page/sport-page.component").then((m) => m.SportPageComponent),
                children: [
                  {
                    path: "in-play",
                    loadComponent: () => import("./pages/content/sport-page/tabs/ip-markets-tab/ip-markets-tab.component").then((m) => m.IpMarketsTabComponent),
                  },
                  {
                    path: "popular",
                    loadComponent: () => import("./pages/content/home/sport-highlights/sport-highlights.component").then((m) => m.SportHighlightsComponent),
                    data: { type: "popular" },
                  },
                  {
                    path: "upcoming",
                    loadComponent: () => import("./pages/content/sport-page/tabs/upcoming-tab/upcoming-tab.component").then((m) => m.UpcomingTabComponent),
                    children: [
                      {
                        path: "date/:date",
                        loadComponent: () =>
                          import("./pages/content/sport-page/tabs/upcoming-tab/upcoming-sub-tab/upcoming-sub-tab.component").then(
                            (m) => m.UpcomingSubTabComponent,
                          ),
                      },
                      { path: "", redirectTo: "date/today", pathMatch: "full" },
                    ],
                  },
                  {
                    path: "competition",
                    loadComponent: () =>
                      import("./pages/content/sport-page/tabs/competitions-tab/competitions-tab.component").then((m) => m.CompetitionsTabComponent),
                    children: [
                      {
                        path: "leagues",
                        loadComponent: () =>
                          import("./pages/content/sport-page/tabs/competitions-tab/leagues-sub-tab/leagues-sub-tab.component").then(
                            (m) => m.LeaguesSubTabComponent,
                          ),
                      },
                      {
                        path: "countries",
                        loadComponent: () =>
                          import("./pages/content/sport-page/tabs/competitions-tab/countries-sub-tab/countries-sub-tab.component").then(
                            (m) => m.CountriesSubTabComponent,
                          ),
                      },
                      { path: "", redirectTo: "leagues", pathMatch: "full" },
                    ],
                  },
                  {
                    path: "league/:leagueId/:leagueName",
                    loadComponent: () => import("./pages/content/home/sport-highlights/sport-highlights.component").then((m) => m.SportHighlightsComponent),
                  },
                  { path: "", redirectTo: "in-play", pathMatch: "full" },
                ],
              },
              {
                path: "event-markets/:eventId",
                loadComponent: () => import("./pages/content/market-layout/market-layout.component").then((m) => m.MarketLayoutComponent),
                children: [
                  {
                    path: "market/:marketId",
                    loadComponent: () =>
                      import("./pages/content/market-layout/single-market-view/single-market-view.component").then((m) => m.SingleMarketViewComponent),
                  },
                ],
              },
              { path: "market/:marketId", loadComponent: () => import("./pages/content/market-layout/market/market.component").then((m) => m.MarketComponent) },
              { path: "", redirectTo: "home", pathMatch: "full" },
            ],
          },
          {
            path: "",
            loadComponent: () => import("./pages/betting-manager/open-bets/open-bets.component").then((m) => m.OpenBetsComponent),
            outlet: "betting",
          },
        ],
      },
      { path: "my-account", loadComponent: () => import("./pages/user-pages/my-account/my-account.component").then((m) => m.MyAccountComponent) },
      { path: "slip-settings", loadComponent: () => import("./pages/betting-manager/bet-slip/bet-slip.component").then((m) => m.BetSlipComponent) },
      {
        path: "bets",
        loadComponent: () => import("./pages/user-pages/report/bets/bets.component").then((m) => m.BetsComponent),
      },
      {
        path: "statement",
        loadComponent: () => import("./pages/user-pages/report/statement/statement.component").then((m) => m.StatementComponent),
      },
      {
        path: "betting-pl",
        loadComponent: () => import("./pages/user-pages/report/betting-pl/betting-pl.component").then((m) => m.BettingPlComponent),
      },
      {
        path: "deposit",
        loadComponent: () => import("./pages/user-pages/deposit/deposit.component").then((m) => m.DepositComponent),
      },
      {
        path: "withdraw",
        loadComponent: () => import("./pages/user-pages/withdraw/withdraw.component").then((m) => m.WithdrawComponent),
      },
      {
        path: "wallet-transfer",
        loadComponent: () => import("./pages/user-pages/wallet-transfer/wallet-transfer.component").then((m) => m.WalletTransferComponent),
      },
      {
        path: "search-data/:page/:size/:keyword",
        loadComponent: () => import("./pages/search-results/search-results.component").then((m) => m.SearchResultsComponent),
      },
    ],
  },
  {
    path: "",
    loadComponent: () => import("./layouts/blank/blank.component").then((m) => m.BlankComponent),
    children: [
      {
        path: "",
        loadChildren: () => import("./pages/authentication/authentication.module").then((m) => m.AuthenticationModule),
      },
    ],
  },
  {
    path: "market-liquidity/:marketId/:selectionId",
    loadComponent: () => import("./pages/content/components/market-liquidity/market-liquidity.component").then((m) => m.MarketLiquidityComponent),
  },
  {
    path: "market-debugger/:marketId",
    loadComponent: () =>
      import("./pages/content/components/market-update-debugger/market-update-debugger.component").then((m) => m.MarketUpdateDebuggerComponent),
  },
  {
    path: "**",
    redirectTo: "authentication/error",
  },
];
